resultsToMerge